export default "__VITE_ASSET__fb22e135__"